<template>
  <div class="purple-round-input input-wrapper" :class="{ disabled: disabled }">
    <div class="h-full px-4 inline-flex items-center" @click="disabled ? '' : $emit('edit-code')">
      <span class="inline-block">
        {{ countryCode.value }}
      </span>
      <img class="ml-2" src="../../../assets/common/chevron-down.svg" />
    </div>
    <input
      class="flex-1 h-12 px-3 outline-none"
      type="text"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="$t('login.enter_phone_number')"
      inputmode="numeric"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  name: 'Phone',
  props: {
    countryCode: Object,
    value: String,
    disabled: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.disabled div {
  opacity: 0.7;
}
</style>
